module.exports = __webpack_public_path__ + "img/img3.598382ea.png";